import { Injectable, inject } from '@angular/core'
import { ModalService } from 'src/shared/modal'
import { MatchedOfferFormulaDialogComponent, MatchedOfferFormulaDialogData, MatchedOfferFormulaDialogResult } from './matched-offer-formula-dialog.component'

@Injectable()
export class MatchedOfferFormulaDialogService {
  private readonly modal = inject(ModalService)


  show(data: MatchedOfferFormulaDialogData): Promise<MatchedOfferFormulaDialogResult | undefined> {
    return this.modal.openDialog<MatchedOfferFormulaDialogComponent, MatchedOfferFormulaDialogData, MatchedOfferFormulaDialogResult>(
      MatchedOfferFormulaDialogComponent, data, {
      panelClass: ['tc-dialog', 'modal-lg'],
      width: null,
      maxWidth: null,
      disableClose: true,
    }).toPromise()
  }
}
